import { render, staticRenderFns } from "./VerDetalleHorasLaboradasPorSemana.vue?vue&type=template&id=1c53e092&scoped=true&"
import script from "./VerDetalleHorasLaboradasPorSemana.vue?vue&type=script&lang=js&"
export * from "./VerDetalleHorasLaboradasPorSemana.vue?vue&type=script&lang=js&"
import style0 from "./VerDetalleHorasLaboradasPorSemana.vue?vue&type=style&index=0&id=1c53e092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c53e092",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardSubtitle,VCardTitle,VCol,VDialog,VRow,VTextField})
